const words = [
  "Vakmanschap",
  "Duurzaam bouwen",
  "Tijdloze architectuur",
  "Oog voor detail",
  "Kwaliteitsafwerking",
  "Persoonlijke aanpak",
];

const WordSequence = ({ hidden = false }) => (
  <div className="marquee-sequence" aria-hidden={hidden || undefined}>
    {words.map((word) => (
      <span key={word} className="flex shrink-0 items-center">
        <span className="font-heading font-light text-cream/90 text-2xl md:text-4xl tracking-tight px-8">
          {word}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-beige/70" />
      </span>
    ))}
  </div>
);

const Marquee = () => {
  return (
    <section className="bg-forest py-8 md:py-10 overflow-hidden">
      <div className="marquee-track">
        <WordSequence />
        <WordSequence hidden />
      </div>
    </section>
  );
};

export default Marquee;
